<template>
  <div>
    <keep-alive v-if="$route.meta.notCache">
      <router-view></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.notCache"></router-view>
    <set-server-auto-login></set-server-auto-login>
    <set-router-remote-modal></set-router-remote-modal>
    <edit-bar-info></edit-bar-info>
    <set-remote-assistance></set-remote-assistance>
    <bar-group-manage></bar-group-manage>
    <receive-bar></receive-bar>
    <send-bar></send-bar>
    <bar-move-to></bar-move-to>
    <restart-serve-modal></restart-serve-modal>
    <del-bar-group-to></del-bar-group-to>
    <edit-server-label></edit-server-label>
    <server-application></server-application>
  </div>
</template>
<script>
import SetServerAutoLogin from './modals/setServerAutoLogin'
import SetRouterRemoteModal from './modals/setRouterRemoteModal'
import EditBarInfo from './modals/editBarInfo'
import SetRemoteAssistance from './modals/setRemoteAssistance'
import BarGroupManage from './modals/barGroupManage'
import ReceiveBar from './modals/receiveBar'
import SendBar from './modals/sendBar'
import BarMoveTo from './modals/barMoveto'
import RestartServeModal from './modals/restartServeModal'
import delBarGroupTo from './modals/delBarGroupTo'
import editServerLabel from './modals/editServerLabel'
import serverApplication from './modals/serverApplication/modal'

export default {
  name: 'barManager',
  components: {
    SetServerAutoLogin,
    SetRouterRemoteModal,
    EditBarInfo,
    SetRemoteAssistance,
    BarGroupManage,
    ReceiveBar,
    SendBar,
    BarMoveTo,
    RestartServeModal,
    delBarGroupTo,
    editServerLabel,
    serverApplication,
  },
}
</script>
